import { Typography, Box, styled, Button } from '@mui/material';

export const StyledContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  minWidth: '100%',
  height: '100%',
  padding: theme.spacing(3),
  gap: theme.spacing(4),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
  },
}));

export const StyledHeader = styled(Typography)(() => ({
  fontSize: 32,
  fontWeight: 500,
}));

export const StyledSubscriptionGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: theme.spacing(3),
  gridTemplateColumns: 'repeat(12, 1fr)',
  [theme.breakpoints.down('md')]: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    padding: theme.spacing(2, 0),
  },
}));

export const StyledSubscriptionBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gridColumn: 'span 4',
  padding: theme.spacing(2),
  gap: theme.spacing(1.5),
  background: theme.palette.grey[800],
  borderRadius: theme.spacing(1),
}));

export const StyledTypography = styled(Typography)(() => ({
  fontSize: 12,
}));

export const StyledButtonContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  [theme.breakpoints.down('sm')]: {
    gap: theme.spacing(2),
  },
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  gap: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(1),
  },
}));
